import React from "react";
import styled, { keyframes } from "styled-components";

const ITEMS = [
  "PR Strategy",
  "Communications Infrastructure",
  "Media Relations",
  "Crisis Response",
  "Brand Voice Development",
  "Stakeholder Engagement",
  "Fractional Leadership",
  "Narrative Frameworks",
  "Public Affairs",
  "Development Leadership",
  "Messaging Architecture",
  "Campaign Planning",
  "Government Relations",
];

export default function Marquee() {
  // Duplicate for seamless loop
  const items = [...ITEMS, ...ITEMS];

  return (
    <Strip aria-hidden="true">
      <Track>
        {items.map((item, i) => (
          <Item key={i}>
            <Dot />
            {item}
          </Item>
        ))}
      </Track>
    </Strip>
  );
}

const scroll = keyframes`
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
`;

const Strip = styled.div`
  width: 100%;
  background: #111111;
  border-top: 1px solid rgba(255,255,255,0.06);
  border-bottom: 1px solid rgba(255,255,255,0.06);
  overflow: hidden;
  padding: 0.875rem 0;
`;

const Track = styled.div`
  display: flex;
  width: max-content;
  animation: ${scroll} 32s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`;

const Item = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 2rem;
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9E9E8E;
  white-space: nowrap;
  transition: color 0.2s;

  &:hover {
    color: #C4A25D;
  }
`;

const Dot = styled.span`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #C4A25D;
  flex-shrink: 0;
  opacity: 0.6;
`;
